/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { useEffect } from 'react';
import './hubspotFormStyles.css';
import ReactDOM from 'react-dom/client';
import { Dropdown } from './HubspotComponents/Dropdown';

export interface HubspotContactFormProps {
  region: string;
  portalId: string;
  formId: string;
  onFormReady?: () => void;
  onFormSubmitted?: () => void;
  hubspotId?: string;
}

declare global {
  interface Window {
    hbspt: {
      forms: {
        create: ({
          region,
          portalId,
          formId,
          target,
        }: {
          region: string;
          portalId: string;
          formId: string;
          target: string;
          onFormSubmitted?: () => void;
          onFormReady?: () => void;
        }) => void;
      };
    };
  }
}

export const MktHubspotForm: React.FC<HubspotContactFormProps> = ({
  formId,
  portalId,
  region,
  onFormReady,
  onFormSubmitted,
  hubspotId = 'hubspot-form',
}) => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = '//js.hsforms.net/forms/embed/v2.js';
    script.id = 'hubspot-id';
    document.body.appendChild(script);

    script.addEventListener('load', () => {
      window.hbspt.forms.create({
        region: region,
        portalId: portalId,
        formId: formId,
        target: `#${hubspotId}`,

        onFormSubmitted: function () {
          if (onFormSubmitted) {
            onFormSubmitted();
          }
        },
        onFormReady: function () {
          const selects = document.querySelectorAll('select');

          //**Dropdown Replacer */
          for (const iterator of selects as unknown as HTMLSelectElement[]) {
            const select = document.getElementById(iterator.id);

            const options = document
              .getElementById(iterator.id)
              ?.querySelectorAll('option');

            const fieldParentClassName = select?.parentNode?.parentNode;
            //@ts-ignore
            const label = fieldParentClassName?.firstChild?.innerText;

            fieldParentClassName?.removeChild(
              fieldParentClassName.firstChild as HTMLElement,
            );

            const root = ReactDOM.createRoot(select?.parentNode as HTMLElement);

            root.render(
              <Dropdown
                id={iterator.id}
                name={iterator.name}
                options={options as unknown as HTMLOptionElement[]}
                label={label}
              />,
            );
          }

          if (onFormReady) {
            onFormReady();
          }
        },
      });
    });
  }, []);

  return (
    <div id="hubspot-container">
      <div id={hubspotId} />
    </div>
  );
};
